module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pt-0"
  }, [_c('v-card', [_c('v-card-title', {
    style: ({
      backgroundColor: _vm.styles.general.theme_color_light
    }),
    attrs: {
      "dark": ""
    }
  }, [_vm._v("\n    TOP 5 OPPORTUNITIES\n  ")]), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": "",
      "dense": ""
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.title,
      attrs: {
        "avatar": ""
      },
      on: {
        "click": function($event) {
          return _vm.openModal(item)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      staticClass: "grey lighten-1 white--text"
    }, [_vm._v("work")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.solicitationname.toString().toUpperCase()))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.posteddate))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('opportunities-modal', {
    attrs: {
      "dialog": _vm.openDialog,
      "item": _vm.selectedItem
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-580d0dee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/grouppage/top5/Top5.vue
// module id = 1686
// module chunks = 17